import React from 'react';
import Skeleton from 'components/Loading/Skeleton';
import SkeletonChart from 'components/Loading/SkeletonChart';
import SkeletonTable from 'components/Loading/SkeletonTable';

/**
 * Loading skeletons for the strategy calculator, dimensioned to match the real
 * content so swapping them out causes no layout shift. Replaces the old centered
 * pulse loader (which jumped from ~72px to a full chart + table on load).
 */

/** Mirrors the 6-up metrics row (Premium / Max Profit / Max Loss / Index / PoP / Breakevens). */
export function StrategyStatsSkeleton() {
  return (
    <div className="mt-2 px-2">
      <div className="mx-auto max-w-6xl rounded-md bg-palette-black-4 px-2 py-2.5">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="flex flex-col items-center space-y-2 px-1 py-1">
              <Skeleton width="w-20" height="h-2.5" />
              <Skeleton width="w-16" height="h-4" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/** Mirrors the metric tabs, payoff chart, time + price/IV sliders, and payoff table. */
export function StrategyChartTableSkeleton() {
  return (
    <div className="mt-4 px-2">
      {/* metric tabs */}
      <div className="mb-3 grid grid-cols-3 gap-1 lg:grid-cols-6">
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} height="h-8" rounded="md" />
        ))}
      </div>

      {/* payoff chart (matches the 400px ResponsiveContainer) */}
      <SkeletonChart height="400px" showAxes />

      {/* time scrubber */}
      <div className="mt-3 space-y-2">
        <div className="flex justify-between">
          <Skeleton width="w-24" height="h-3" />
          <Skeleton width="w-16" height="h-3" />
        </div>
        <Skeleton height="h-2" rounded="full" />
      </div>

      {/* price range + IV sliders */}
      <div className="mt-4 grid grid-cols-2 gap-4">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="space-y-2">
            <Skeleton width="w-28" height="h-3" />
            <Skeleton height="h-2" rounded="full" />
          </div>
        ))}
      </div>

      {/* payoff table */}
      <div className="mt-6">
        <SkeletonTable rows={12} columns={8} height="480px" />
      </div>
    </div>
  );
}
